module.exports = __webpack_public_path__ + "img/slide1.0e25b27d.jpg";